import { FC } from 'react';

import { StyledPopupMain } from './index.styles';

const PopupMain: FC<{ className?: string; children: JSX.Element | JSX.Element[] }> = ({ children, className }) => {
  return <StyledPopupMain className={className}>{children}</StyledPopupMain>;
};

export default PopupMain;
